// extracted by mini-css-extract-plugin
module.exports = {"LoginScreen":"styles_LoginScreen__1K4jG","loginBox":"styles_loginBox__1OEJp","button":"styles_button__DYJ4w"};